import { render, staticRenderFns } from "./FKomoditiTable.vue?vue&type=template&id=9ffa4460&scoped=true"
import script from "./FKomoditiTable.vue?vue&type=script&lang=js"
export * from "./FKomoditiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffa4460",
  null
  
)

export default component.exports